<template>
    <div class="projects-timeline">
        <div class="content">
            <div class="text-center mb-2">
                <h5>Completed Projects</h5>
                <small class="text-muted">Last 12 Months</small>
            </div>
            <canvas class="chart" width="100%" ref="canvas"></canvas>
        </div>
    </div>
</template>
<script>
    import Chart from 'chart.js';

    export default {

        props: ['keys', 'values'],

        mounted() {
            this.render();
        },

        methods: {
            render() {
                const chart = new Chart(this.$refs.canvas.getContext('2d'), {
                    type: 'bar',
                    data: {
                        display: false,
                        labels: this.keys,
                        datasets: [
                            {
                                label: "Projects",
                                fillColor: "rgba(220,220,220,0.2)",
                                strokeColor: "rgba(220,220,220,1)",
                                pointColor: "rgba(220,220,220,1)",
                                pointStrokeColor: "#fff",
                                pointHighlightFill: "#fff",
                                pointHighlightStroke: "rgba(220,220,220,1)",
                                data: this.values
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        }
                    }
                })
            }
        }
    }
</script>
